import Alt from "alt"
import { Dispatcher } from "flux"
import actionListener from "./actionListener.es6"

class AuthorDispatcher extends Dispatcher {
  dispatch(payload) {
    super.dispatch(payload)
    actionListener.dispatch(payload)
  }
}

class AuthorAlt extends Alt {
  constructor(settings) {
    super(settings)

    this._modules = {}
  }

  getModules(key) {
    return this._modules[key]
  }

  setModules(key, modules) {
    this._modules[key] = modules
  }
}

let instance = new AuthorAlt({
  dispatcher: new AuthorDispatcher(),
})

if (process.env.NODE_ENV === "development") {
  window.authorAlt = instance
}

Alt.debug("author", instance)

export default instance
